(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Countdown", [], factory);
	else if(typeof exports === 'object')
		exports["Countdown"] = factory();
	else
		root["Countdown"] = factory();
})(this, function() {
return 